import { Injectable } from '@angular/core';
import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { v4 as uuidv4 } from 'uuid';
import { AppSettings } from 'src/app/app.config';

@Injectable({
  providedIn: 'root',
})
export class CorrelationIdInterceptor implements HttpInterceptor {
  intercept(
    request: HttpRequest<unknown>,
    next: HttpHandler
  ): Observable<HttpEvent<unknown>> {
    if (!this.isBackendRequest(request.url)) {
      return next.handle(request);
    }

    const correlationId = uuidv4();
    const frontendPath = window.location.pathname;

    const requestWithTrackingHeaders = request.clone({
      setHeaders: {
        'x-correlation-id': correlationId,
        'x-frontend-path': frontendPath,
      },
    });

    return next.handle(requestWithTrackingHeaders);
  }

  private isBackendRequest(url: string): boolean {
    return (
      url.startsWith(AppSettings.API_PROD_ENDPOINT) ||
      url.startsWith('/atrio/') ||
      url.startsWith('/auth/') ||
      url.startsWith('/common/') ||
      url.startsWith('/api/')
    );
  }
}
